import { StampProgrammeModel as r } from "./stampProgramme.model.js";
import { Adapter as o, getAdapter as t } from "../../../adapter.js";
import { ScopeAdapter as m } from "../../scope/scope.adapter.js";
import { StampProgrammeSettingsAdapter as p } from "./stampProgrammeSettings/stampProgrammeSettigns.adapter.js";
import { StampProgrammeDesignModelAdapter as d } from "./stampProgrammeDesign/stampProgrammeDesign.adapter.js";
class l extends o {
  adapt(e) {
    return new r({
      code: e.code,
      endDate: e.end_date ? new Date(e.end_date * 1e3) : void 0,
      startDate: e.start_date ? new Date(e.start_date * 1e3) : void 0,
      id: e.id,
      name: e.name,
      scope: t(m).adapt(e.scope),
      status: e.status,
      settings: t(p).adapt(e.settings),
      design: t(d).adapt(e.design)
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  l as StampProgrammeAdapter
};
//# sourceMappingURL=stampProgramme.adapter.js.map
